export default {
  RawTemplate: require('./RawTemplate').default,
  HtmlTemplate: require('./HtmlTemplate').default,
  MjmlTemplate: require('./MjmlTemplate').default,
};
